export const DEFAULT_CATEGORY_ID = "a98e11f4-d067-4e55-b39c-a8caae33fe7c";
export const DEFAULT_CATEGORY_NAME = "Uncategorized";

export const GLOSS_CREDITS_CATEGORY_ID = "b1c2d3e4-f5a6-4b7c-8d9e-0f1a2b3c4d5e";
export const GLOSS_CREDITS_CATEGORY_NAME = "GLOSS Credits";
